import { Badge } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import type { Reports } from 'shared/hooks/use-load-reports';

interface periodicityLabelProps {
  type: Reports[number]['periodicity']['type'];
}

export const PeriodicityLabel = ({ type }: periodicityLabelProps) => {
  const { t } = useTranslation();
  const isWeekly = type === 'weekly';

  const [text, color] = isWeekly
    ? [t(i18nKeys.DATES.PERIOD_NAMES.WEEKLY), 'indigo']
    : [t(i18nKeys.DATES.PERIOD_NAMES.MONTHLY), 'cyan'];

  return (
    <Badge variant="light" color={color}>
      {text}
    </Badge>
  );
};
